export default {
  methods: {
    selectHandlerIpad () {
      if ((/(i[PSa-z\s]+);.*?CPU\s([OSPa-z\s]+(?:([\d_]+)|;))/g.test(navigator.userAgent)) || (/version\/([\w\.]+) .*(mobile ?safari|safari)/i.test(navigator.userAgent))) {
        Array.from(document.getElementsByClassName('select-filtered')).forEach((item) => {
          item.children[0].children[0].removeAttribute('readOnly')
          item.children[0].children[0].onblur = function () {
            const _this = this
            setTimeout(() => {
              _this.removeAttribute('readOnly')
            }, 200)
          }
        })
      }
    }
  }
}
